import { Loader } from "@googlemaps/js-api-loader";

export default function InitMapsLibrary() {
    const loader = new Loader({
        apiKey: atob("QUl6YVN5RDJJa1c0ZTU5cG55RGJUM2I1Zld0SjZhXzEzQy0zR1Jz"),
        version: "weekly",
    });

    loader.load().then(() => {
        document.querySelectorAll('.gmaps-container').forEach((mapsContainer) => {
            let latitude = mapsContainer.dataset.latitude === "" ? 48.20467625488314 : parseFloat(mapsContainer.dataset.latitude);
            let longitude = mapsContainer.dataset.longitude === "" ? 15.625505463289828 : parseFloat(mapsContainer.dataset.longitude);

            let map = new google.maps.Map(mapsContainer, {
                center: {
                    lat: latitude,
                    lng: longitude,
                },
                zoom: 15,
                styles: stylesArray,
                zoomControl: false,
                scaleControl: false,
                fullscreenControl: false,
                streetViewControl: false,
                mapTypeControl: false,
                rotateControl: false
            });

			let marker = new google.maps.Marker({
				map: map,
				position: {
					lat: latitude,
					lng: longitude,
				},
				icon: {
					url: '/svg/pin.svg',
				scaledSize: new google.maps.Size(25, 35),
				labelOrigin: new google.maps.Point(80, 20)
				}
			});
        });
    });
}

const stylesArray = [
	{
		elementType: "geometry",
		stylers: [
			{
				color: "#f5f5f5",
			},
		],
	},
	{
		elementType: "labels.icon",
		stylers: [
			{
				visibility: "off",
			},
		],
	},
	{
		elementType: "labels.text.fill",
		stylers: [
			{
				color: "#616161",
			},
		],
	},
	{
		elementType: "labels.text.stroke",
		stylers: [
			{
				color: "#f5f5f5",
			},
		],
	},
	{
		featureType: "administrative.land_parcel",
		elementType: "labels.text.fill",
		stylers: [
			{
				color: "#bdbdbd",
			},
		],
	},
	{
		featureType: "poi",
		elementType: "geometry",
		stylers: [
			{
				color: "#eeeeee",
			},
		],
	},
	{
		featureType: "poi",
		elementType: "labels.text.fill",
		stylers: [
			{
				color: "#757575",
			},
		],
	},
	{
		featureType: "poi.park",
		elementType: "geometry",
		stylers: [
			{
				color: "#e5e5e5",
			},
		],
	},
	{
		featureType: "poi.park",
		elementType: "labels.text.fill",
		stylers: [
			{
				color: "#9e9e9e",
			},
		],
	},
	{
		featureType: "road",
		elementType: "geometry",
		stylers: [
			{
				color: "#ffffff",
			},
		],
	},
	{
		featureType: "road.arterial",
		elementType: "labels.text.fill",
		stylers: [
			{
				color: "#757575",
			},
		],
	},
	{
		featureType: "road.highway",
		elementType: "geometry",
		stylers: [
			{
				color: "#dadada",
			},
		],
	},
	{
		featureType: "road.highway",
		elementType: "labels.text.fill",
		stylers: [
			{
				color: "#616161",
			},
		],
	},
	{
		featureType: "road.local",
		elementType: "labels.text.fill",
		stylers: [
			{
				color: "#9e9e9e",
			},
		],
	},
	{
		featureType: "transit.line",
		elementType: "geometry",
		stylers: [
			{
				color: "#e5e5e5",
			},
		],
	},
	{
		featureType: "transit.station",
		elementType: "geometry",
		stylers: [
			{
				color: "#eeeeee",
			},
		],
	},
	{
		featureType: "water",
		elementType: "geometry",
		stylers: [
			{
				color: "#c9c9c9",
			},
		],
	},
	{
		featureType: "water",
		elementType: "labels.text.fill",
		stylers: [
			{
				color: "#9e9e9e",
			},
		],
	},
];
